var _rect, _g, _path, _path2, _path3, _g2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g3, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _g4, _path37, _path38, _path39, _g5, _path40, _path41, _path42, _g6, _path43, _path44, _path45, _g7, _path46, _path47, _path48, _g8, _path49, _path50, _path51, _g9, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _g10, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _g11, _path81, _path82, _path83, _path84, _g12, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFunctionImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 626,
    height: 859,
    viewBox: "0 0 626 859",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2169_4068",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 626,
    height: 859
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 626,
    height: 859,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2169_4068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.24 -0.5L682.24 0L681.74 859H43.2402L141.24 -0.5Z",
    fill: "#7F32CE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M43 860.5L100.5 358L546.143 359.267C582.838 359.372 606.924 397.652 591.137 430.777L455.416 715.57C449.416 728.16 438.43 737.672 425.111 741.809L43 860.5Z",
    fill: "#66347F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4783 895.196C31.2338 877.138 31.8167 821.165 71.4289 803.927L558.259 592.08C590.601 578.006 626.957 600.943 628.179 636.194L635.544 848.544C636.493 875.918 615.24 898.961 587.878 900.223L139.704 920.898C131.719 921.267 123.761 919.715 116.499 916.373L70.4783 895.196Z",
    fill: "#7149C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M286.817 889.927C279.512 889.314 275.327 881.31 278.993 874.962L356.739 740.301C370.546 716.387 401.126 708.193 425.04 722L625.082 837.494C631.689 841.309 631.762 850.819 625.215 854.736L545.811 902.238C536.83 907.61 526.39 910.029 515.961 909.154L286.817 889.927Z",
    fill: "#162F15"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 379.156,
    y: 139.961,
    width: 391.48,
    height: 387.982,
    rx: 50,
    transform: "rotate(-91.7219 379.156 139.961)",
    fill: "#162F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8544 42.9056C15.9493 9.59822 41.363 -26.8721 77.4248 -25.3609L679.531 -0.128726C681.264 -0.0560956 682.632 1.3701 682.632 3.10479C682.632 4.75376 681.392 6.13909 679.753 6.32131L80.8095 72.918C59.0446 75.338 38.2911 63.1143 29.8544 42.9056Z",
    fill: "#9C61D9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M483.282 258.702C483.282 258.702 441.591 224.652 387.368 239.75C333.145 254.848 310.456 301.555 279.348 333.666C263.063 350.486 239.003 356.69 219.658 369.614C157.836 411.021 166.957 504.076 214.684 539.188C255.982 569.577 307.589 572.754 374.736 550.341C441.884 527.927 489.945 514.459 531.595 450.263C573.244 386.067 534.638 304.908 483.282 258.702Z",
    fill: "#1D397E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M483.282 258.702C483.282 258.702 441.591 224.652 387.368 239.75C333.145 254.848 310.456 301.555 279.348 333.666C263.063 350.486 239.003 356.69 219.658 369.614C157.836 411.021 166.957 504.076 214.684 539.188C255.982 569.577 307.589 572.754 374.736 550.341C441.884 527.927 489.945 514.459 531.595 450.263C573.244 386.067 534.638 304.908 483.282 258.702Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2169_4068",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 178,
    y: 335,
    width: 86,
    height: 140
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M202.98 473.379V443.45C202.98 443.45 206.7 431.42 212.41 430.174L218.111 428.937L263.456 429.129V335.924H178.627V474.424L202.98 473.379Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2169_4068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.584 354.893C235.584 354.893 235.584 351.182 230.384 345.99C225.184 340.798 221.857 337.822 221.857 337.822C221.857 337.822 219.257 346.358 224.081 351.558C227.629 355.217 231.477 358.572 235.584 361.59V354.893Z",
    fill: "#1D397E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.002 378.067C228.002 378.067 228.002 374.355 222.81 369.164C217.619 363.972 214.275 360.996 214.275 360.996C214.275 360.996 211.675 369.532 216.499 374.723C220.046 378.383 223.893 381.739 228.002 384.755V378.067Z",
    fill: "#1D397E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.216 361.214C235.216 361.214 235.609 357.527 241.319 352.904C247.029 348.281 250.632 345.689 250.632 345.689C250.632 345.689 252.304 354.451 246.971 359.107C243.044 362.369 238.849 365.295 234.431 367.852L235.216 361.214Z",
    fill: "#1D397E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.104 388.576C226.104 388.576 226.882 384.948 233.051 380.96C239.221 376.973 243.083 374.766 243.083 374.766C243.083 374.766 243.836 383.652 238.067 387.724C233.824 390.556 229.35 393.026 224.691 395.105L226.104 388.576Z",
    fill: "#1D397E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.817 418.412C227.817 418.412 227.817 414.701 233.017 409.509C238.217 404.317 241.545 401.35 241.545 401.35C241.545 401.35 244.144 409.877 239.321 415.077C235.773 418.736 231.925 422.091 227.817 425.109V418.412Z",
    fill: "#1D397E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.734 425.695C227.734 425.695 228.26 422.025 223.855 416.148C219.449 410.271 216.573 406.852 216.573 406.852C216.573 406.852 212.786 414.927 216.824 420.754C219.816 424.875 223.147 428.74 226.781 432.308L227.734 425.695Z",
    fill: "#1D397E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.609 447.28C222.609 447.28 222.609 443.568 227.801 438.377C232.992 433.185 236.336 430.209 236.336 430.209C236.336 430.209 238.936 438.745 234.113 443.936C230.566 447.596 226.718 450.952 222.609 453.968V447.28Z",
    fill: "#1D397E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.079 466.842C226.079 466.842 225.143 463.256 228.846 456.919C232.55 450.582 235.041 446.887 235.041 446.887C235.041 446.887 239.714 454.478 236.362 460.731C233.854 465.163 230.98 469.377 227.768 473.329L226.079 466.842Z",
    fill: "#1D397E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.011 353.939C235.75 357.803 235.276 361.649 234.59 365.46C232.533 376.068 227.4 382.915 225.394 392.496C223.387 402.076 229.231 414.424 227.651 426.73C226.071 439.036 221.28 445.883 222.635 454.092C223.989 462.302 231.404 485.016 231.404 485.016",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.166 363.68L240.759 359.383",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.425 358.73L233.076 354.566",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.661 392.054C225.661 392.054 230.343 388.535 235.166 385.023",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.002 384.748C228.002 384.748 224.098 377.09 219.7 371.99",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.002 423.689C230.682 418.768 234.061 414.263 238.034 410.312",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.09 428.896C225.669 425.551 223.971 422.329 222.016 419.265C219.282 415.227 218.864 414.709 218.864 414.709",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.609 454.094C223.784 451.15 225.182 448.299 226.789 445.567C228.41 443.031 230.239 440.635 232.257 438.402",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.767 473.304C227.499 470.488 227.984 467.652 229.172 465.086C231.128 461.316 233.352 456.366 234.254 454.41",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.149 404.46C193.149 404.46 192.748 402.136 195.44 398.316C198.132 394.495 199.904 392.271 199.904 392.271C199.904 392.271 202.462 397.338 200.004 401.116C198.173 403.789 196.123 406.306 193.876 408.64L193.149 404.46Z",
    fill: "#1D397E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.397 418.169C200.397 418.169 199.996 415.845 202.688 412.025C205.38 408.204 207.16 405.98 207.16 405.98C207.16 405.98 209.668 411.047 207.252 414.825C205.426 417.502 203.376 420.019 201.124 422.349L200.397 418.169Z",
    fill: "#1D397E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.043 408.389C194.043 408.389 193.4 406.115 189.311 403.841C185.223 401.567 182.665 400.33 182.665 400.33C182.665 400.33 182.565 406.007 186.419 408.347C189.228 409.966 192.167 411.347 195.205 412.477L194.043 408.389Z",
    fill: "#1D397E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.721 424.558C202.721 424.558 201.885 422.367 197.538 420.536C193.19 418.706 190.565 417.744 190.565 417.744C190.565 417.744 191.059 423.395 195.138 425.318C198.109 426.636 201.185 427.701 204.334 428.503L202.721 424.558Z",
    fill: "#1D397E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.886 443.45C204.886 443.45 204.485 441.126 200.664 438.434C196.844 435.742 194.428 434.254 194.428 434.254C194.428 434.254 193.725 439.889 197.312 442.614C199.935 444.513 202.712 446.191 205.613 447.63L204.886 443.45Z",
    fill: "#1D397E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.731 448.007C205.731 448.007 205.003 445.767 207.127 441.604C209.25 437.44 210.688 434.982 210.688 434.982C210.688 434.982 213.94 439.639 212.042 443.727C210.61 446.651 208.932 449.447 207.026 452.087L205.731 448.007Z",
    fill: "#1D397E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.251 466.776C212.251 466.776 212.527 464.435 216.18 461.526C219.834 458.617 222.208 456.986 222.208 456.986C222.208 456.986 223.228 462.571 219.8 465.505C217.292 467.557 214.616 469.395 211.8 470.998L212.251 466.776Z",
    fill: "#1D397E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.29 460.991C211.29 460.991 210.888 458.667 207.11 455.975C203.331 453.283 200.873 451.795 200.873 451.795C200.873 451.795 200.171 457.43 203.757 460.155C206.379 462.056 209.156 463.734 212.059 465.171L211.29 460.991Z",
    fill: "#1D397E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.24 473.638C211.24 473.638 211.441 471.281 208.423 467.711C205.405 464.141 203.448 462.076 203.448 462.076C203.448 462.076 201.342 467.343 204.126 470.896C206.178 473.405 208.437 475.737 210.88 477.868L211.24 473.638Z",
    fill: "#1D397E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.756 403.916C193.338 406.308 194.053 408.667 194.896 410.98C197.337 417.417 201.3 421.146 203.624 426.931C205.948 432.716 203.624 441.143 205.923 448.667C208.222 456.191 211.992 459.978 212.026 465.278C212.059 470.579 210.12 484.916 210.12 484.916",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.345 409.927L190.365 407.846",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.642 406.85L194.662 403.982",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.381 426.69C203.381 426.69 200.037 425.018 196.693 423.346",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.116 422.359C202.093 419.274 203.382 416.297 204.962 413.473",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.346 446.786C203.135 443.982 200.527 441.515 197.604 439.463",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.483 449.947C207.012 447.695 207.728 445.492 208.624 443.36C209.894 440.534 210.087 440.166 210.087 440.166",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.85 469.283C213.141 467.681 214.57 466.195 216.122 464.844C217.113 464.115 218.044 463.307 218.905 462.428",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.026 465.263C210.963 463.544 209.77 461.909 208.456 460.372C207.172 458.961 205.774 457.658 204.276 456.477",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.88 477.87C210.745 476.07 210.133 474.339 209.108 472.854C207.436 470.697 205.547 467.838 204.761 466.709",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M534.864 303.252H475.717V380.707H534.864V303.252Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M525.726 315.217H484.862V368.729H525.726V315.217Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M445.913 275.088H399.674V335.639H445.913V275.088Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M438.773 284.443H406.821V326.277H438.773V284.443Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M214.048 575.389L211.34 583.774H508.956L507.05 575.823L214.048 575.389Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M514.624 477.651C514.808 463.096 515 455.79 515 449.77C515 431.077 498.28 428.937 498.28 428.937H218.103C218.103 428.937 203.423 427.332 203.423 448.834C203.423 456.542 202.863 465.755 203.197 478.094",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M236.779 503.199H481.527",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M203.423 523.914V540.986C203.423 542.538 204.039 544.026 205.137 545.124C206.234 546.221 207.723 546.838 209.275 546.838H306.752V522.092C306.752 513.356 307.396 503.106 307.396 503.106V438.985C307.396 438.985 306.401 433.376 308.232 429.639",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M306.794 546.872H421.819L422.547 503.199V439.488C422.547 439.488 422.354 433.41 420.039 429.205",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M421.819 546.873H509.457C510.863 546.873 512.214 546.326 513.224 545.348C514.234 544.369 514.823 543.036 514.866 541.631C515.075 534.349 515.435 526.884 515.435 524.334",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M182.331 518.683L191.201 575.389H528.343L537.213 517.922",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M198.231 575.823L202.62 588.129H209.216L214.049 575.389L198.231 575.823Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M507.05 575.823L511.439 588.129H518.035L522.867 575.389L507.05 575.823Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M213.012 521.165C210.12 522.689 206.955 523.624 203.699 523.915C197.285 524.333 190.881 522.964 185.198 519.961C180.751 517.653 174.33 514.694 174.932 508.691C175.534 502.689 179.948 496.36 183.735 491.838C187.777 486.91 192.781 482.856 198.44 479.925C205.329 476.489 213.806 474.207 220.695 477.066C224.684 478.832 228.314 481.317 231.404 484.397C235.174 488.026 240.04 493.694 238.577 499.378C237.214 504.67 230.994 508.299 226.948 511.434C222.601 514.786 218.028 518.623 213.012 521.165Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M505.102 521.165C507.994 522.688 511.159 523.622 514.415 523.915C520.834 524.334 527.244 522.965 532.932 519.961C537.371 517.653 543.8 514.694 543.19 508.691C542.58 502.689 538.174 496.36 534.387 491.838C530.345 486.91 525.341 482.856 519.682 479.925C512.793 476.489 504.316 474.207 497.427 477.066C493.438 478.843 489.811 481.34 486.726 484.431C482.956 488.059 478.091 493.727 479.554 499.412C480.916 504.704 487.136 508.332 491.191 511.467C495.521 514.786 500.077 518.623 505.102 521.165Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M514.415 523.914H424.796C424.796 523.914 422.171 524.65 422.171 517.41C422.171 517.41 421.987 523.872 417.322 523.872H308.266C308.266 523.872 306.468 524.056 306.644 519.918C306.82 515.78 306.468 523.153 305.206 523.872C303.944 524.591 204.777 523.872 204.777 523.872",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M360.985 625.02C381.148 625.02 397.493 618.283 397.493 609.972C397.493 601.661 381.148 594.924 360.985 594.924C340.822 594.924 324.477 601.661 324.477 609.972C324.477 618.283 340.822 625.02 360.985 625.02Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M335.427 340.22C335.427 340.22 334.198 334.418 330.152 334.418C326.106 334.418 325.044 338.891 327.594 343.999C330.144 349.106 337.392 352.308 337.818 349.324C338.245 346.339 335.427 340.22 335.427 340.22Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M398.771 317.078C398.771 317.078 400.535 322.972 398.771 328.565C397.816 331.743 396.32 334.732 394.349 337.401V320.614L398.771 317.078Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M345.1 593.903C345.1 593.903 338.73 603.784 332.669 608.566C326.608 613.348 327.569 615.572 332.034 616.533C336.498 617.495 343.186 616.215 347.332 612.069C349.812 609.598 351.956 606.813 353.711 603.784L353.544 606.092C353.541 606.146 353.555 606.2 353.583 606.246C353.611 606.293 353.652 606.33 353.702 606.353C353.751 606.376 353.805 606.384 353.859 606.376C353.913 606.369 353.963 606.345 354.004 606.309L358.811 601.87C359.798 599.21 359.909 596.304 359.128 593.577C357.858 588.803 350.208 588.159 345.1 593.903Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M337.384 614.921C331.741 615.222 329.45 613.993 328.556 613.191C327.987 614.929 329.392 615.966 332.042 616.535C336.506 617.488 343.194 616.217 347.341 612.07C349.82 609.6 351.965 606.814 353.719 603.786L353.552 606.093C353.55 606.147 353.564 606.201 353.592 606.247C353.62 606.294 353.661 606.331 353.71 606.354C353.759 606.377 353.814 606.386 353.868 606.378C353.921 606.37 353.972 606.347 354.012 606.31L358.819 601.871C359.463 600.18 359.731 598.368 359.605 596.562C357.757 598.343 354.589 601.42 352.39 603.61C349.13 606.904 345.652 614.486 337.384 614.921Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M378.741 593.903C378.741 593.903 385.119 603.784 391.172 608.566C397.225 613.348 396.272 615.572 391.816 616.533C387.36 617.495 380.655 616.215 376.509 612.069C374.033 609.597 371.891 606.812 370.138 603.784L370.297 606.092C370.299 606.146 370.286 606.2 370.258 606.246C370.23 606.293 370.188 606.33 370.139 606.353C370.09 606.376 370.035 606.384 369.982 606.376C369.928 606.369 369.878 606.345 369.837 606.309L365.039 601.886C364.046 599.228 363.935 596.32 364.721 593.593C366 588.803 373.641 588.159 378.741 593.903Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M386.324 615.138C378.925 612.964 375.882 608.174 373.709 605.348C371.794 602.84 365.675 598.117 364.228 596.988C364.173 598.65 364.458 600.306 365.064 601.854L369.863 606.293C369.903 606.329 369.954 606.353 370.007 606.361C370.061 606.368 370.116 606.36 370.165 606.337C370.214 606.314 370.255 606.277 370.283 606.23C370.311 606.184 370.325 606.13 370.323 606.076L370.164 603.768C371.917 606.796 374.059 609.581 376.534 612.053C380.714 616.233 387.402 617.47 391.841 616.517C394.667 615.907 396.072 614.787 395.185 612.839C394.092 614.042 392.671 614.901 391.097 615.309C389.523 615.717 387.864 615.658 386.324 615.138Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M361.82 466.33L326.6 462.894L327.235 464.8C327.235 464.8 331.415 501.458 334.884 518.989C338.354 536.52 340.945 543.852 340.945 543.852C340.795 547.615 341.224 551.379 342.216 555.013C343.813 560.112 344.131 572.569 345.401 578.922C346.672 585.276 346.045 588.804 346.045 588.804C346.045 588.804 342.534 592.624 342.851 593.577C343.056 594.304 343.163 595.054 343.169 595.809C343.169 595.809 345.084 600.909 350.183 600.909C355.283 600.909 359.747 596.771 359.747 596.771L361.018 491.05L361.854 490.992L362.648 491.05L363.927 596.771C363.927 596.771 368.391 600.909 373.491 600.909C378.59 600.909 380.497 595.809 380.497 595.809C380.503 595.054 380.612 594.303 380.823 593.577C381.14 592.624 377.629 588.804 377.629 588.804C377.629 588.804 376.994 585.292 378.273 578.922C379.552 572.552 379.861 560.112 381.458 555.013C382.448 551.379 382.873 547.615 382.72 543.852C382.72 543.852 385.27 536.52 388.781 518.989C392.292 501.458 396.431 464.783 396.431 464.783L397.066 462.877L361.82 466.33Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2169_4068",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 326,
    y: 462,
    width: 72,
    height: 139
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M361.82 466.33L326.6 462.894L327.235 464.8C327.235 464.8 331.415 501.458 334.884 518.989C338.354 536.52 340.945 543.852 340.945 543.852C340.795 547.615 341.224 551.379 342.216 555.013C343.813 560.112 344.131 572.569 345.401 578.922C346.672 585.276 346.045 588.804 346.045 588.804C346.045 588.804 342.534 592.624 342.851 593.577C343.056 594.304 343.163 595.054 343.169 595.809C343.169 595.809 345.084 600.909 350.183 600.909C355.283 600.909 359.747 596.771 359.747 596.771L361.018 491.05L361.854 490.992L362.648 491.05L363.927 596.771C363.927 596.771 368.391 600.909 373.491 600.909C378.59 600.909 380.497 595.809 380.497 595.809C380.503 595.054 380.612 594.303 380.823 593.577C381.14 592.624 377.629 588.804 377.629 588.804C377.629 588.804 376.994 585.292 378.273 578.922C379.552 572.552 379.861 560.112 381.458 555.013C382.448 551.379 382.873 547.615 382.72 543.852C382.72 543.852 385.27 536.52 388.781 518.989C392.292 501.458 396.431 464.783 396.431 464.783L397.066 462.877L361.82 466.33Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2169_4068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.002 559.252C372.705 566.625 367.246 575.345 362.539 580.888",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.535 545.691C384.535 545.691 382.796 549.035 380.112 553.817",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.263 552.797C388.263 552.797 380.137 575.469 362.205 586.304",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.323 555.506C370.323 555.506 363.217 569.718 362.205 571.39",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.815 544.68C336.815 544.68 347.683 565.321 362.205 567.352",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.544 565.998C340.544 565.998 353.084 573.781 362.539 575.136",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.46 592.449C356.263 593.479 359.248 593.92 362.23 593.745",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.07 588.805C347.258 589.596 348.498 590.306 349.782 590.928",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.079 584.607C356.176 586.754 358.902 588.177 361.862 588.67",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.492 586.004C381.492 586.004 373.708 592.776 369.646 594.464",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M361.82 466.33L326.6 462.894L327.235 464.8C327.235 464.8 331.415 501.458 334.884 518.989C338.354 536.52 340.945 543.852 340.945 543.852C340.795 547.615 341.224 551.379 342.216 555.013C343.813 560.112 344.131 572.569 345.401 578.922C346.672 585.276 346.045 588.804 346.045 588.804C346.045 588.804 342.534 592.624 342.851 593.577C343.056 594.304 343.163 595.054 343.169 595.809C343.169 595.809 345.084 600.909 350.183 600.909C355.283 600.909 359.747 596.771 359.747 596.771L361.018 491.05L361.854 490.992L362.648 491.05L363.927 596.771C363.927 596.771 368.391 600.909 373.491 600.909C378.59 600.909 380.497 595.809 380.497 595.809C380.503 595.054 380.612 594.303 380.823 593.577C381.14 592.624 377.629 588.804 377.629 588.804C377.629 588.804 376.994 585.292 378.273 578.922C379.552 572.552 379.861 560.112 381.458 555.013C382.448 551.379 382.873 547.615 382.72 543.852C382.72 543.852 385.27 536.52 388.781 518.989C392.292 501.458 396.431 464.783 396.431 464.783L397.066 462.877L361.82 466.33Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M388.145 358.343C388.145 358.343 372.838 355.467 363.6 355.467C354.363 355.467 339.356 360.566 339.356 360.566L349.28 468.962C349.28 468.962 355.015 471.47 365.214 471.47C375.413 471.47 384.977 466.688 384.977 466.688L388.145 358.343Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M365.933 397.618C376.991 397.618 385.956 388.782 385.956 377.881C385.956 366.98 376.991 358.143 365.933 358.143C354.875 358.143 345.911 366.98 345.911 377.881C345.911 388.782 354.875 397.618 365.933 397.618Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M365.934 392.786C374.286 392.786 381.057 386.113 381.057 377.88C381.057 369.648 374.286 362.975 365.934 362.975C357.581 362.975 350.811 369.648 350.811 377.88C350.811 386.113 357.581 392.786 365.934 392.786Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M341.438 365.056C341.438 365.056 339.691 401.255 363.676 407.793C387.661 414.33 398.128 378.14 395.076 367.238C392.025 356.337 350.158 350.251 341.438 365.056Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M365.934 383.54C376.211 383.54 384.543 376.867 384.543 368.634C384.543 360.402 376.211 353.729 365.934 353.729C355.656 353.729 347.324 360.402 347.324 368.634C347.324 376.867 355.656 383.54 365.934 383.54Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M417.832 403.437C417.832 403.437 484.068 425.607 492.361 412.465C496.834 405.368 478.609 393.605 467.098 389.768C455.586 385.931 423.626 370.824 423.626 370.824",
    fill: "#1D397E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2169_4068",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 417,
    y: 370,
    width: 77,
    height: 47
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M417.832 403.437C417.832 403.437 484.068 425.607 492.361 412.465C496.834 405.368 478.609 393.605 467.098 389.768C455.586 385.931 423.626 370.824 423.626 370.824",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2169_4068)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M473.476 407.584C464.138 407.584 427.83 399.098 418.986 397L417.849 403.437C417.849 403.437 484.085 425.608 492.378 412.466C492.629 412.066 492.815 411.628 492.93 411.17C486.68 408.939 480.111 407.728 473.476 407.584Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.603 391.273L421.452 405.168L429.603 397.451",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M417.832 403.437C417.832 403.437 484.068 425.607 492.361 412.465C496.834 405.368 478.609 393.605 467.098 389.768C455.586 385.931 423.626 370.824 423.626 370.824",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M423.877 393.64L405.351 477.558L377.236 484.588L379.577 422.607L383.832 367.022L385.504 356.58C385.504 356.58 423.417 369.572 426.184 371.494C428.951 373.417 427.856 384.034 427.856 384.034",
    fill: "#1D397E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2169_4068",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 377,
    y: 356,
    width: 52,
    height: 129
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M423.877 393.64L405.351 477.558L377.236 484.588L379.577 422.607L383.832 367.022L385.504 356.58C385.504 356.58 423.417 369.572 426.184 371.494C428.951 373.417 427.856 384.034 427.856 384.034",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2169_4068)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M421.477 404.508L390.98 462.451C390.98 462.451 397.292 438.767 396.899 436.008C396.673 434.403 386.867 440.23 378.716 445.413L377.236 484.588L405.351 477.557L421.477 404.508Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M391.373 359.447C391.373 359.447 401.246 366.545 400.059 382.337C398.872 398.129 395.319 395.763 395.319 395.763C395.319 395.763 397.693 399.307 395.319 399.709C392.944 400.11 388.631 392.603 387.795 394.576C386.959 396.549 382.269 398.915 382.269 398.915L383.807 367.038C383.807 367.038 385.061 358.611 391.373 359.447Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.06 370.992C400.06 370.992 403.404 379.352 401.38 391.274",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.813 383.783C403.813 383.783 405.351 387.085 400.06 400.319",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.869 433.391C410.869 433.391 398.739 456.983 385.73 466.906",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.314 445.738C396.314 445.738 394.767 448.388 387.736 453.914",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M423.877 393.64L405.351 477.558L377.236 484.588L379.577 422.607L383.832 367.022L385.504 356.58C385.504 356.58 423.417 369.572 426.184 371.494C428.951 373.417 427.856 384.034 427.856 384.034",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M389.158 355.945C390.578 358.797 391.379 361.916 391.507 365.099C391.507 369.789 391.716 381.293 392.778 386.618C393.839 391.943 397.25 398.113 396.188 397.904C395.127 397.695 393.848 394.919 391.081 391.726C388.313 388.532 387.461 383.416 385.964 384.486C384.468 385.556 381.709 394.71 381.709 394.71C381.709 394.71 382.135 375.541 382.771 368.301C383.406 361.061 384.903 351.473 389.158 355.945Z",
    fill: "#1D397E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_2169_4068",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 381,
    y: 354,
    width: 16,
    height: 44
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M389.158 355.945C390.578 358.797 391.379 361.916 391.507 365.099C391.507 369.789 391.716 381.293 392.778 386.618C393.839 391.943 397.25 398.113 396.188 397.904C395.127 397.695 393.848 394.919 391.081 391.726C388.313 388.532 387.461 383.416 385.964 384.486C384.468 385.556 381.709 394.71 381.709 394.71C381.709 394.71 382.135 375.541 382.771 368.301C383.406 361.061 384.903 351.473 389.158 355.945Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_2169_4068)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M389.158 355.945C390.578 358.797 391.379 361.916 391.507 365.099C391.507 369.789 391.716 381.293 392.778 386.618C393.839 391.943 397.25 398.113 396.188 397.904C395.127 397.695 393.848 394.919 391.081 391.726C388.313 388.532 387.461 383.416 385.964 384.486C384.468 385.556 381.709 394.71 381.709 394.71C381.709 394.71 382.135 375.541 382.771 368.301C383.406 361.061 384.903 351.473 389.158 355.945Z",
    fill: "black"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M389.158 355.945C390.578 358.797 391.379 361.916 391.507 365.099C391.507 369.789 391.716 381.293 392.778 386.618C393.839 391.943 397.25 398.113 396.188 397.904C395.127 397.695 393.848 394.919 391.081 391.726C388.313 388.532 387.461 383.416 385.964 384.486C384.468 385.556 381.709 394.71 381.709 394.71C381.709 394.71 382.135 375.541 382.771 368.301C383.406 361.061 384.903 351.473 389.158 355.945Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M303.342 374.494C303.342 374.494 276.824 418.61 272.694 427.739C268.564 436.868 262.913 445.295 264.434 449.032C265.956 452.769 270.286 455.553 278.78 455.118C287.274 454.683 314.427 407.524 314.427 407.524L303.342 374.494Z",
    fill: "#1D397E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_2169_4068",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 264,
    y: 374,
    width: 51,
    height: 82
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M303.342 374.494C303.342 374.494 276.824 418.61 272.694 427.739C268.564 436.868 262.913 445.295 264.434 449.032C265.956 452.769 270.286 455.553 278.78 455.118C287.274 454.683 314.427 407.524 314.427 407.524L303.342 374.494Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_2169_4068)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M292.281 441.902C300.131 431.31 308.692 417.198 312.454 410.853L308.081 399.291L282.399 446.659L292.281 441.902Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.287 394.141L310.757 414.205L298.409 404.29",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.562 430.506C278.562 430.506 286.922 434.686 290.467 442.636",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.836 429.863C285.836 429.863 289.59 434.277 290.91 439.126",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M303.342 374.494C303.342 374.494 276.824 418.61 272.694 427.739C268.564 436.868 262.913 445.295 264.434 449.032C265.956 452.769 270.286 455.553 278.78 455.118C287.274 454.683 314.427 407.524 314.427 407.524L303.342 374.494Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M306.51 393.64L325.036 477.558L353.142 484.588L350.802 422.607L346.546 367.022L344.874 356.58C344.874 356.58 306.937 369.572 304.136 371.494C301.335 373.417 302.464 384.034 302.464 384.034",
    fill: "#1D397E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_2169_4068",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 302,
    y: 356,
    width: 52,
    height: 129
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M306.51 393.64L325.036 477.558L353.142 484.588L350.802 422.607L346.546 367.022L344.874 356.58C344.874 356.58 306.937 369.572 304.136 371.494C301.335 373.417 302.464 384.034 302.464 384.034",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_2169_4068)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M325.036 477.558L353.151 484.589L351.981 453.523L315.297 433.426L325.036 477.558Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.021 435.383C320.021 435.383 327.545 445.306 335.905 451.033",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M338.872 387.872C338.872 387.872 333.747 398.138 336.506 398.531C339.265 398.924 341.698 388.123 345.192 391.425L348.678 394.769L345.585 375.273C342.291 378.819 339.978 383.161 338.872 387.872Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.217 360.627C337.217 360.627 331.7 376.511 333.246 389.954",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.821 369.664C330.821 369.664 328.171 383.558 331.038 391.275",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M306.51 393.64L325.036 477.558L353.142 484.588L350.802 422.607L346.546 367.022L344.874 356.58C344.874 356.58 306.937 369.572 304.136 371.494C301.335 373.417 302.464 384.034 302.464 384.034",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M341.23 355.945C339.814 358.798 339.016 361.917 338.889 365.099C338.889 369.789 338.672 381.293 337.61 386.618C336.548 391.943 333.137 398.113 334.233 397.904C335.328 397.695 336.573 394.919 339.341 391.726C342.108 388.532 342.969 383.416 344.457 384.486C345.945 385.556 348.712 394.71 348.712 394.71C348.712 394.71 348.286 375.541 347.65 368.301C347.015 361.061 345.485 351.473 341.23 355.945Z",
    fill: "#1D397E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_2169_4068",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 334,
    y: 354,
    width: 15,
    height: 44
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M341.23 355.945C339.814 358.798 339.016 361.917 338.889 365.099C338.889 369.789 338.672 381.293 337.61 386.618C336.548 391.943 333.137 398.113 334.233 397.904C335.328 397.695 336.573 394.919 339.341 391.726C342.108 388.532 342.969 383.416 344.457 384.486C345.945 385.556 348.712 394.71 348.712 394.71C348.712 394.71 348.286 375.541 347.65 368.301C347.015 361.061 345.485 351.473 341.23 355.945Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_2169_4068)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M342.743 365.057C342.743 365.057 340.193 373.534 342.308 379.009C344.423 384.485 348.411 392.528 348.411 392.528L347.575 368.284",
    fill: "black"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M341.23 355.945C339.814 358.798 339.016 361.917 338.889 365.099C338.889 369.789 338.672 381.293 337.61 386.618C336.548 391.943 333.137 398.113 334.233 397.904C335.328 397.695 336.573 394.919 339.341 391.726C342.108 388.532 342.969 383.416 344.457 384.486C345.945 385.556 348.712 394.71 348.712 394.71C348.712 394.71 348.286 375.541 347.65 368.301C347.015 361.061 345.485 351.473 341.23 355.945Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M334.876 325.028C334.876 325.028 334.876 343.287 337.233 353.887C339.591 364.488 344.298 373.316 356.37 378.323C368.441 383.331 382.871 376.852 389.057 369.194C395.244 361.536 394.65 340.051 394.65 335.336C394.65 330.621 394.943 315.607 394.943 315.607C394.943 315.607 392.585 308.542 382.277 301.762C371.969 294.982 361.67 291.73 348.712 299.698C335.754 307.665 334.876 325.028 334.876 325.028Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M376.45 344.164L383.096 343.955",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M371.468 360.893C371.468 360.893 372.446 357.399 377.612 356.562",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M366.276 344.783V349.356C366.846 349.8 367.31 350.366 367.632 351.013C367.955 351.66 368.129 352.37 368.14 353.093C368.349 355.793 365.908 357.223 363.601 355.467",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M366.276 344.783V349.356C366.846 349.8 367.31 350.366 367.632 351.013C367.955 351.66 368.129 352.37 368.14 353.093C368.349 355.793 365.908 357.223 363.601 355.467",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M352.073 342.184H351.37C350.816 342.184 350.284 341.964 349.892 341.572C349.5 341.18 349.28 340.648 349.28 340.094H354.163C354.163 340.648 353.942 341.18 353.55 341.572C353.158 341.964 352.627 342.184 352.073 342.184Z",
    fill: "#263238"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M347.182 339.951H356.394",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M347.182 341.656H356.394",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M380.68 339.809C380.68 341.356 380.028 342.602 379.217 342.602C378.406 342.602 377.754 341.356 377.754 339.809C377.754 338.263 378.406 337.025 379.217 337.025C380.028 337.025 380.68 338.271 380.68 339.809Z",
    fill: "#263238"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M369.771 331.668C369.771 331.668 375.305 328.474 389.149 330.389",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M359.546 329.961C357.825 327.191 355.448 324.887 352.625 323.253C349.803 321.618 346.621 320.704 343.361 320.59",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M404.072 296.747C400.243 288.797 386.7 276.432 372.855 275.847C361.018 275.337 356.971 279.793 356.01 281.089C355.492 280.713 347.55 275.237 334.098 281.925C334.017 281.969 333.952 282.038 333.915 282.123C333.877 282.208 333.869 282.302 333.891 282.392C333.913 282.482 333.964 282.562 334.036 282.62C334.109 282.677 334.198 282.709 334.291 282.711C334.355 282.713 334.418 282.699 334.475 282.669C344.381 277.711 351.287 279.684 354.104 280.997C352.298 280.688 349.038 280.57 344.298 282.025C336.64 284.383 328.414 292.333 326.34 306.169C324.267 320.005 330.754 331.784 333.112 334.141C335.469 336.499 335.762 341.507 335.762 341.507L335.169 326.191C335.169 326.191 334.876 325.012 338.412 322.663C341.321 320.715 354.054 307.757 358.418 303.276C359.204 307.456 361.344 315.649 366.669 321.183C366.749 321.263 366.857 321.308 366.97 321.309C367.024 321.311 367.078 321.301 367.129 321.281C367.179 321.261 367.224 321.23 367.263 321.192C367.301 321.154 367.332 321.108 367.354 321.058C367.375 321.008 367.386 320.954 367.386 320.899C367.386 320.845 367.375 320.791 367.354 320.74C367.332 320.69 367.301 320.645 367.263 320.607C361.82 314.938 359.797 306.395 359.128 302.541L359.897 301.755C359.897 301.755 363.425 311.469 369.319 316.477C375.213 321.484 382.862 325.606 394.934 321.777C407.006 317.948 411.42 312.355 411.42 312.355C411.42 312.355 407.901 304.714 404.072 296.747Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_2169_4068",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 325,
    y: 275,
    width: 87,
    height: 67
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M404.072 296.747C400.243 288.797 386.7 276.432 372.855 275.847C361.018 275.337 356.971 279.793 356.01 281.089C355.492 280.713 347.55 275.237 334.098 281.925C334.017 281.969 333.952 282.038 333.915 282.123C333.877 282.208 333.869 282.302 333.891 282.392C333.913 282.482 333.964 282.562 334.036 282.62C334.109 282.677 334.198 282.709 334.291 282.711C334.355 282.713 334.418 282.699 334.475 282.669C344.381 277.711 351.287 279.684 354.104 280.997C352.298 280.688 349.038 280.57 344.298 282.025C336.64 284.383 328.414 292.333 326.34 306.169C324.267 320.005 330.754 331.784 333.112 334.141C335.469 336.499 335.762 341.507 335.762 341.507L335.169 326.191C335.169 326.191 334.876 325.012 338.412 322.663C341.321 320.715 354.054 307.757 358.418 303.276C359.204 307.456 361.344 315.649 366.669 321.183C366.749 321.263 366.857 321.308 366.97 321.309C367.024 321.311 367.078 321.301 367.129 321.281C367.179 321.261 367.224 321.23 367.263 321.192C367.301 321.154 367.332 321.108 367.354 321.058C367.375 321.008 367.386 320.954 367.386 320.899C367.386 320.845 367.375 320.791 367.354 320.74C367.332 320.69 367.301 320.645 367.263 320.607C361.82 314.938 359.797 306.395 359.128 302.541L359.897 301.755C359.897 301.755 363.425 311.469 369.319 316.477C375.213 321.484 382.862 325.606 394.934 321.777C407.006 317.948 411.42 312.355 411.42 312.355C411.42 312.355 407.901 304.714 404.072 296.747Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_2169_4068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.42 311.461C410.384 314.219 414.07 310.123 414.07 310.123",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.984 289.641C360.984 289.641 367.305 303.853 382.403 309.496",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.566 284.625C360.566 284.625 384.81 295.894 394.424 296.329C404.038 296.764 405.292 294.657 405.292 294.657",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.969 290.477C355.969 290.477 337.995 300.091 332.979 310.959C327.963 321.827 330.053 329.351 330.053 329.351",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.953 293.303C331.751 294.21 330.632 295.223 329.609 296.329",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.296 287.133C347.967 286.842 341.677 288.263 336.088 291.246",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M361.937 336.315C357.884 334.498 353.492 333.559 349.05 333.559C344.608 333.559 340.217 334.498 336.163 336.315C336.163 336.315 333.714 336.558 333.714 338.522C333.714 340.487 335.428 340.236 335.428 340.236C335.428 340.236 335.762 349.524 339.608 352.266C343.044 354.724 350.66 355.46 354.58 353.988C358.501 352.517 360.967 349.808 361.703 347.359C362.439 344.909 361.937 336.315 361.937 336.315Z",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M367.748 336.315C371.8 334.498 376.19 333.559 380.631 333.559C385.071 333.559 389.461 334.498 393.513 336.315C393.513 336.315 395.971 336.557 395.971 338.522C395.971 340.487 394.257 340.219 394.257 340.219C394.257 340.219 393.923 349.507 390.077 352.249C386.641 354.707 379.034 355.443 375.105 353.971C371.175 352.5 368.726 349.791 367.99 347.342C367.255 344.892 367.748 336.315 367.748 336.315Z",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M361.938 336.314C363.815 335.559 365.912 335.559 367.79 336.314",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M362.673 339.994H366.844",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M392.752 340.22C392.752 340.22 393.99 334.418 398.036 334.418C402.082 334.418 403.144 338.891 400.586 343.999C398.027 349.106 390.788 352.308 390.37 349.324C389.952 346.339 392.752 340.22 392.752 340.22Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M410.024 331.45C410.024 331.45 398.947 331.667 392.343 331.024C385.739 330.38 390.671 336.04 393.513 336.316C396.941 336.73 400.395 336.884 403.846 336.775C406.391 336.679 408.928 337.115 411.295 338.054C411.295 338.054 414.923 334.008 410.024 331.45Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M403.202 351.922C401.082 349.346 399.227 346.562 397.668 343.613C395.536 339.357 394.901 337.443 398.947 337.861C402.993 338.279 404.699 342.124 405.76 345.318C406.822 348.512 409.38 348.512 409.38 348.512L413 338.078L420.248 344.465L413.652 366.803C413.652 366.803 404.707 362.331 403.428 360.416C402.149 358.502 403.42 353.594 403.202 351.922Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M423.224 338.262C423.224 338.262 422.589 334.86 419.604 334.216C416.62 333.572 411.512 329.961 409.806 330.596C408.101 331.231 404.907 341.464 404.907 343.136C404.907 344.808 406.822 346.547 407.465 346.547C408.109 346.547 413.652 336.774 413.652 336.774L423.224 338.262Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M423.442 340.82C423.442 340.82 424.503 338.48 423.442 337.418C422.38 336.356 415.558 334.216 413.217 333.79C410.877 333.363 410.45 334.216 409.171 337.418C407.892 340.62 405.125 345.084 406.404 346.146C407.683 347.207 409.38 348.486 409.38 348.486L413.853 339.332L423.442 340.82Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M413 351.263C413 351.263 408.745 349.591 408.102 348.279C407.458 346.966 411.721 336.349 412.365 336.14C413.009 335.931 415.768 336.775 416.62 337.202C417.473 337.628 424.077 338.69 424.504 341.465C424.93 344.241 420.458 359.991 420.884 361.697C421.31 363.402 424.721 365.317 424.721 365.317L419.605 374.044C419.605 374.044 411.512 367.022 408.528 365.526C405.543 364.029 409.598 359.139 410.66 356.58C411.721 354.022 413 351.263 413 351.263Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M413 351.263L415.985 345.721",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M413.853 345.512L417.899 345.938",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M423.442 363.402L414.923 372.13L423.015 379.37L430.89 367.658L423.442 363.402Z",
    fill: "#1D397E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M475.658 413.427C473.986 413 439.627 395.344 435.58 392.786C431.534 390.228 421.945 384.485 421.945 381.5C421.945 378.515 430.255 366.377 430.255 366.377C430.255 366.377 432.387 363.183 435.789 365.098C439.192 367.012 470.977 387.227 479.069 391.49C487.162 395.754 493.34 398.947 493.766 407.249C494.192 415.55 487.162 417.047 482.48 416.445",
    fill: "#1D397E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_2169_4068",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 421,
    y: 364,
    width: 73,
    height: 53
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M475.658 413.427C473.986 413 439.627 395.344 435.58 392.786C431.534 390.228 421.945 384.485 421.945 381.5C421.945 378.515 430.255 366.377 430.255 366.377C430.255 366.377 432.387 363.183 435.789 365.098C439.192 367.012 470.977 387.227 479.069 391.49C487.162 395.754 493.34 398.947 493.766 407.249C494.192 415.55 487.162 417.047 482.48 416.445",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_2169_4068)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M468.569 400.896C457.124 398.672 437.06 392.277 432.312 390.73C433.557 391.566 434.702 392.235 435.58 392.787C439.627 395.345 473.953 413.001 475.658 413.427L482.48 416.412C487.161 417.047 494.184 415.576 493.766 407.216C493.348 398.856 487.161 395.713 479.069 391.457C474.27 388.949 461.128 380.79 450.528 374.186C463.118 383.147 481.142 396.34 481.61 398.689C482.338 402.342 481.61 403.429 468.569 400.896Z",
    fill: "black"
  }))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M475.658 413.427C473.986 413 439.627 395.344 435.58 392.786C431.534 390.228 421.945 384.485 421.945 381.5C421.945 378.515 430.255 366.377 430.255 366.377C430.255 366.377 432.387 363.183 435.789 365.098C439.192 367.012 470.977 387.227 479.069 391.49C487.162 395.754 493.34 398.947 493.766 407.249C494.192 415.55 487.162 417.047 482.48 416.445",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M410.659 407.275L388.087 411.748L388.94 417.709L401.505 420.049L409.806 412.601L410.659 407.275Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M279.892 439.443C281.46 439.11 283.081 439.11 284.649 439.443C286.217 439.775 287.698 440.433 288.996 441.375C293.778 444.635 305.516 451.407 315.297 454.851C325.078 458.295 326.591 458.546 325.329 464.632C324.066 470.718 319.677 479.413 315.556 480.516C311.435 481.62 302.949 475.299 289.907 468.344C276.866 461.388 265.128 457.259 263.824 452.042C262.52 446.825 268.171 437.922 268.171 437.922",
    fill: "#1D397E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_2169_4068",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 263,
    y: 437,
    width: 63,
    height: 44
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M279.892 439.443C281.46 439.11 283.081 439.11 284.649 439.443C286.217 439.775 287.698 440.433 288.996 441.375C293.778 444.635 305.516 451.407 315.297 454.851C325.078 458.295 326.591 458.546 325.329 464.632C324.066 470.718 319.677 479.413 315.556 480.516C311.435 481.62 302.949 475.299 289.907 468.344C276.866 461.388 265.128 457.259 263.824 452.042C262.52 446.825 268.171 437.922 268.171 437.922",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_2169_4068)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M315.297 454.875L314.16 454.457L321.508 458.896C321.508 458.896 313.215 458.896 312.037 465.216C310.858 471.537 314.795 475.081 312.429 475.867C310.064 476.653 278.479 461.655 278.479 461.655L279.508 463.126C282.735 464.706 286.246 466.412 289.866 468.343C302.907 475.299 311.384 481.602 315.514 480.515C319.644 479.428 323.983 470.734 325.287 464.631C326.591 458.528 325.036 458.353 315.297 454.875Z",
    fill: "black"
  }))), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M279.892 439.443C281.46 439.11 283.081 439.11 284.649 439.443C286.217 439.775 287.698 440.433 288.996 441.375C293.778 444.635 305.516 451.407 315.297 454.851C325.078 458.295 326.591 458.546 325.329 464.632C324.066 470.718 319.677 479.413 315.556 480.516C311.435 481.62 302.949 475.299 289.907 468.344C276.866 461.388 265.128 457.259 263.824 452.042C262.52 446.825 268.171 437.922 268.171 437.922",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M373.106 460.962C373.106 460.962 377.662 461.798 380.923 460.962C384.183 460.126 384.4 461.798 382.879 464.657C381.357 467.516 377.662 468.787 375.28 468.569C372.897 468.352 369.194 463.353 373.106 460.962Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M332.678 469.004C332.678 469.004 338.329 467.7 340.502 466.178C342.676 464.657 359.848 453.137 362.021 453.137C364.195 453.137 378.741 464.439 378.967 465.309C379.193 466.178 374.845 471.612 373.541 472.699C372.237 473.786 367.02 480.307 365.716 481.611C364.412 482.915 359.413 485.306 357.891 485.741C356.37 486.175 354.196 484.905 354.631 483.35C355.066 481.795 355.467 480.524 355.467 480.524C355.467 480.524 347.207 484.654 342.86 483.567C338.513 482.48 328.297 477.264 328.297 477.264L332.678 469.004Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M355.5 469.875C355.5 469.875 365.933 479.004 365.716 481.579L355.5 469.875Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M355.5 469.875C355.5 469.875 365.933 479.004 365.716 481.579",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M358.326 462.701L370.498 475.525",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M362.455 456.615L375.062 470.526",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M355.5 480.524C355.5 480.524 359.195 479.22 358.76 481.36L355.5 480.524Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M355.5 480.524C355.5 480.524 359.195 479.22 358.76 481.36",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M322.461 462.918L334.165 467.7L328.079 481.394L316.375 475.742C316.375 475.742 315.948 467.483 322.461 462.918Z",
    fill: "#1D397E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunctionImg);
export default __webpack_public_path__ + "static/media/function_img.c31217003fdccc24fd3f2e5c5a7fdbc9.svg";
export { ForwardRef as ReactComponent };